<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :row-data="rowData"
          style="width: 100%;min-width: 160px;height: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div v-if="$store.getters.enableFrontEndPlugin">
            <micro-app
              name="child-sale-role-hide-remotebooking"
              :url="$store.getters.frontEndPluginUrl+'/saleRoleHideItem'"
              router-mode="pure"
              destroy
              @datachange="saleRoleHideDataChange"
            />
            <micro-app
              name="child-customer-sales-display-remotebooking"
              :url="$store.getters.frontEndPluginUrl+'/customerSalesDisplayItem'"
              router-mode="pure"
              destroy
              @datachange="customerSalesDisplayDataChange"
            />
          </div>
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <div v-show="action==='look'">
                <el-button no="1" type="primary" @click="goBack">{{ $t('CargoMsg.Cargo_ReturnQuery') }}</el-button>
                <el-button no="2" :disabled="currentRow.preverifyState === 7" type="success" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
                <el-button no="3" type="primary" @click="toCopy">{{ $t('SeaExport.Copy') }}</el-button>
                <el-button no="4" type="success" :disabled="currentRow.preverifyState === 7" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>
                <el-button
                  no="5"
                  type="primary"
                  @click="toAdd({lob:'SE'})"
                >{{ $t('CargoMsg.Cargo_AddSeaBooking') }}</el-button>
                <el-button
                  no="6"
                  type="primary"
                  @click="toAdd({lob:'AE'})"
                >{{ $t('CargoMsg.Cargo_AddAirBooking') }}</el-button>
                <el-button
                  no="7"
                  type="primary"
                  @click="toAdd({lob:'RE'})"
                >{{ $t('CargoMsg.Cargo_AddRailwayBooking') }}</el-button>
                <el-button v-show="!submitState" :disabled="currentRow.preverifyState === 7" no="8" type="primary" @click="$emit('lockJob',currentRow)">{{ $t('CargoMsg.Cargo_HoldSubmission') }}</el-button>
                <el-button v-show="submitState" :disabled="currentRow.preverifyState === 7" no="9" type="primary" @click="$emit('submitJob',currentRow)">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
                <el-button
                  v-show="isHc && $checkPermission(['button_RemoteBooking_revoke'])"
                  no="revoke"
                  :disabled="currentRow.preverifyState !== 4"
                  type="danger"
                  @click="toRevoke"
                >{{ $t('SeaExport.Invalid') }}</el-button>
                <img
                  v-show="preverifyStateIcon"
                  :src="preverifyStateIcon"
                  width="100"
                  height="99"
                  style="position: fixed;z-index: 99;right: 25%;margin: -10px 0 0 0;"
                >
                <span style="font-size:12px;padding: 5px 9px;color:unset;" v-html="commonInfo.jobTitle" />
              </div>
              <!-- im入口 -->
              <CargoIm v-show="imCacheKey && action==='look'" ref="cargoIm" />
              <div v-show="action!=='look'" class="new" style="border-left:none;padding-left:0">
                <el-button no="10" type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                <el-button no="11" type="success" @click="cancelEdit">{{ $t('common.btn.cancel') }}</el-button>
                <el-button no="12" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                <span style="font-size:12px;padding: 5px 9px;color:unset;" v-html="commonInfo.jobTitle" />
              </div>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <el-tab-pane
                v-if="paramsOfTab.lob === 'SE'"
                :key="1"
                :lazy="true"
                name="tabSeBooking"
                :label="$t('CargoMsg.Cargo_Consignation')"
              >
                <tab-se-booking-UICustom v-if="$store.state.uiCustom.enable" ref="tabSeBooking" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
                <tab-se-booking v-else ref="tabSeBooking" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
              </el-tab-pane>
              <el-tab-pane
                v-if="paramsOfTab.lob === 'AE'"
                :key="2"
                :lazy="true"
                name="tabAeBooking"
                :label="$t('CargoMsg.Cargo_Consignation')"
              >
                <tab-ae-booking-UICustom v-if="$store.state.uiCustom.enable" ref="tabAeBooking" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
                <tab-ae-booking v-else ref="tabAeBooking" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
              </el-tab-pane>
              <el-tab-pane
                v-if="paramsOfTab.lob === 'RE' || paramsOfTab.lob === 'RI'"
                key="railway"
                :lazy="true"
                name="tabReBooking"
                :label="$t('CargoMsg.Cargo_Consignation')"
              >
                <tab-railway-booking-UICustom v-if="$store.state.uiCustom.enable" ref="tabReBooking" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
                <tab-re-booking v-else ref="tabReBooking" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
              </el-tab-pane>
              <!-- 目的港派车tab -->
              <el-tab-pane
                v-if="paramsOfTab.dischargingPortDoor"
                key="tabDischargingTrucking"
                :lazy="true"
                name="tabDischargingTrucking"
                :label="$t('SeaExport.DispatchVehiclesAtDestination')"
              >
                <tab-discharging-trucking ref="tabDischargingTrucking" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" page-source="remoteBooking" />
              </el-tab-pane>
              <!-- 目的港清关数据tab -->
              <el-tab-pane
                v-if="paramsOfTab.destPortCustomsClearance"
                key="tabDestinationCustomsData"
                :lazy="true"
                name="tabDestinationCustomsData"
                :label="$t('SeaExport.PortOfDestinationCustomsClearance')"
              >
                <tab-destination-customs-data ref="tabDestinationCustomsData" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
              </el-tab-pane>
              <el-tab-pane
                v-if="paramsOfTab.uuid && (paramsOfTab.lob === 'SE' ? paramsOfTab.customs : true)"
                :key="3"
                :lazy="true"
                name="tabCustomsInfo"
                :label="$t('SeaExport.CustomsDeclaration')"
              >
                <tab-customs-info v-if="paramsOfTab.lob==='SE'" ref="tabCustomsInfo" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
                <tab-customs-info-ae v-else ref="tabCustomsInfo" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
              </el-tab-pane>
              <el-tab-pane
                v-if="Boolean(paramsOfTab.uuid) && paramsOfTab.landTransportation"
                :key="4"
                :lazy="true"
                name="tabTrucking"
                :label="$t('SeaExport.Trucking')"
              >
                <tab-trucking ref="tabTrucking" :context="context" :action="action" :is-sales-for-szfs="isSalesForSzfs" />
              </el-tab-pane>
              <el-tab-pane
                v-if="paramsOfTab.uuid && paramsOfTab.lob === 'SE' && paramsOfTab.cargoType === 'DG'"
                :key="5"
                :lazy="true"
                name="tabSpecialGoods"
                :label="$t('SpecialGoods.label')"
              >
                <tab-special-goods ref="tabSpecialGoods" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="$checkPermission(['tab_Charge_chargeView'])"
                :key="6"
                :lazy="true"
                name="tabCharges"
                :label="$t('SeaExport.Charge')"
              >
                <tab-charges ref="tabCharges" :context="context" :action="action" view-source="RemoteBooking" :sale-role-hide="saleRoleHide" :customer-sales-display="customerSalesDisplay" />
              </el-tab-pane>
              <el-tab-pane
                v-if="Boolean(paramsOfTab.uuid)"
                :key="7"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
              >
                <tab-file-history ref="tabFileHistory" :context="context" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="currentRow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      :close-callback="batchCheckingWindow.closeHandler"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="currentRow.lob"
      :job="currentRow"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
      :close-callback="checkingWindow.closeHandler"
    />
    <!-- 验证规则-远程订舱保存节点弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      :lob="checkingSaveJobWindow.lob"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
  </div>
</template>

<script>
import { BookingWorkspaceContext } from './bookingWorkspaceContext'
import icon1 from '@/assets/remote-booking/icon-1.png'
import icon2 from '@/assets/remote-booking/icon-2.png'
import icon3 from '@/assets/remote-booking/icon-3.png'
import icon4 from '@/assets/remote-booking/icon-4.png'
import icon7 from '@/assets/remote-booking/icon-7.png'
import iconEn1 from '@/assets/remote-booking/icon-en-1.png'
import iconEn2 from '@/assets/remote-booking/icon-en-2.png'
import iconEn3 from '@/assets/remote-booking/icon-en-3.png'
import iconEn4 from '@/assets/remote-booking/icon-en-4.png'
import iconEn7 from '@/assets/remote-booking/icon-en-7.png'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import tabSeBooking from './tabs/tabSeBooking.vue'
import tabSeBookingUICustom from './tabs/tabSeBookingUICustom.vue'
import tabAeBooking from './tabs/tabAeBooking.vue'
import tabAeBookingUICustom from './tabs/tabAeBookingUICustom.vue'
import tabReBooking from './tabs/tabReBooking.vue'
import tabRailwayBookingUICustom from './tabs/tabRailwayBookingUICustom.vue'
import tabSpecialGoods from './tabs/tabSpecialGoods.vue'
import tabCustomsInfo from '@/components/Cargo/Job/booking/tabs/tabCustomsInfo'
import tabCustomsInfoAe from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabCustomsInfo' // 空出报关
import tabTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTrucking'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import { TabError } from '@/utils/class/TabError'
import { ensureExecuteSuccess, deepCopy, sleep, cleanCircleObject } from '@/utils/commonUtil'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { EstimateProfitUtil } from '@/class/cargo/model/utils/EstimateProfitUtil'
import { CreditControlUtil } from '@/class/cargo/model/utils/CreditControlUtil'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { saveCopyJob, saveSeaBookingSpace } from '@/api/seaExport/seaExportJob'
import { acceptCallbackWebOrder } from '@/api/webOrder/webOrder'
import { validateMBL, saveAeBookingSpace, aeSaveCopyJob } from '@/api/AirExport/airExportJob'
import { saveRailwayExport, saveCopyJob as railwaySaveCopyJob } from '@/api/railwayExport/reBooking'
import { setQuotationJobNo } from '@/api/price/quotation'
import StrUtils from '@/utils/StrUtils'
import lodash from 'lodash'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { Company } from '@/class/model/mdm/Company'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { batchRevokeJob, submitPreVerifyState, submitSkipPreVerify, validateRevokeJob } from '@/api/booking/job'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoIm from '@/components/Cargo/Common/CargoIm'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow'
import tabDischargingTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabDischargingTrucking.vue'
import tabDestinationCustomsData from './tabs/tabDestinationCustomsData.vue'
import microApp from '@micro-zoe/micro-app'
import { cache, cacheName } from '@/utils/cacheManager'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'
import { cacheKeys, resolveSpecificField2ItemByCustomType } from '@/utils/basicDataCache'

export default {
  name: 'RemoteBookingWorkspace',
  components: {
    tabDischargingTrucking,
    tabDestinationCustomsData,
    cargoLeftRightResize, cargoTemplateSelectorDialog, tabSeBooking, tabSeBookingUICustom, tabAeBooking, tabAeBookingUICustom, tabReBooking, tabRailwayBookingUICustom, tabSpecialGoods, tabCustomsInfo,
    tabCustomsInfoAe, tabTrucking, tabCharges, tabFileHistory, EstimateValidationDialog, BatchCheckingWindow, CheckingWindow, CargoIm, checkingSaveJobWindow
  },
  props: {
    parentContext: { type: Object, required: true },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      imCacheKey: '',
      context: new BookingWorkspaceContext(this.parentContext),
      action: 'look',
      // webAccept：来自官网订单接单，保存成功后用于 acceptCallback 回写官网订单（仅 webAccept 落单时有值）
      webAcceptSourceOrderId: '',
      rowData: [],
      currentRow: {},
      paramsOfTab: {},
      activeTabName: '',
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => { }
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        closeHandler: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null,
        closeHandler: null
      },
      checkingSaveJobWindow: {
        lob: 'AE',
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: []
      },
      commonInfo: {
        jobTitle: ''
      },
      saleRoleHideData: { // 子应用销售角色移除搜索条件和显示字段
        viewSource: 'RemoteBooking',
        hide: false
      },
      saleRoleHide: false,
      customerSalesDisplayData: { // 销售角色可选结算对象范围外的显示
        viewSource: 'RemoteBooking',
        notDisplay: false
      },
      customerSalesDisplay: false,
      sopTemplateConfigSE: {}, // SOP模板配置(海运出口)
      sopTemplateConfigAE: {}, // SOP模板配置(空运出口)
      sopTemplateConfigRE: {}, // SOP模板配置(铁路出口)
      sopTemplateConfigRI: {} // SOP模板配置(铁路进口)
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isNew() {
      return this.action === 'add' || this.action === 'copy'
    },
    preverifyStateIcon() {
      switch (this.currentRow.preverifyState) {
        case 1:
          return this.isZh ? icon1 : iconEn1
        case 2:
          return this.isZh ? icon2 : iconEn2
        case 3:
          return this.isZh ? icon3 : iconEn3
        case 4:
          return this.isZh ? icon4 : iconEn4
        case 7:
          return this.isZh ? icon7 : iconEn7
      }
      return ''
    },
    submitState() {
      return this.currentRow.preverifyState === 3 || this.currentRow.preverifyState === 4
    },
    isHc() {
      return cache.config ? String(cache.config.get('ToExoSystem')) === 'HC' : false
    },
    sopTemplateConfig() {
      switch (this.currentRow.lob) {
        case 'SE':
          return this.sopTemplateConfigSE
        case 'AE':
          return this.sopTemplateConfigAE
        case 'RE':
          return this.sopTemplateConfigRE
        case 'RI':
          return this.sopTemplateConfigRI
        default:
          return {}
      }
    }
  },
  created() {
    this.gridOptions = {
      rowSelection: 'single',
      suppressCellSelection: true,
      suppressContextMenu: true,
      treeData: true,
      groupDefaultExpanded: 2,
      getDataPath: data => {
        return (data.path || '').split(',')
      },
      autoGroupColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 160,
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true,
          innerRenderer: params => {
            return params.value
          }
        },
        tooltip: params => {
          return params.data.jobNo
        },
        suppressMenu: true
      },
      columnDefs: [],
      context: {
        componentParent: this
      },
      onRowClicked: this.onRowClicked
    }
    this.gridApi = null
    this.pendTabSet = new Set()
    this.chargeAccountIdObject = null
    this.isRefresh = false
    getSopTemplateConfig({ lob: 'SE' }).then(res => {
      this.sopTemplateConfigSE = res.data
    })
    getSopTemplateConfig({ lob: 'AE' }).then(res => {
      this.sopTemplateConfigAE = res.data
    })
    getSopTemplateConfig({ lob: 'RE' }).then(res => {
      this.sopTemplateConfigRE = res.data
    })
    getSopTemplateConfig({ lob: 'RI' }).then(res => {
      this.sopTemplateConfigRI = res.data
    })
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    // 页面状态切换（action改变）时调用
    async onShow(action, rowData, selectedRow) {
      if (action === 'edit' && this.isHc) {
        selectedRow.containerUsages = '' // 需要刷新，因为在查看状态可以【门点-添加装箱】
      }
      this.imCacheKey = sessionStorage.getItem('imCacheKey')
      this.action = action
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      // 远程订舱接口返回了version, 导致job不加载, 这里清空
      selectedRow.version = 0
      /* 先将原始数据赋给currentRow、paramsOfTab，让页面先展示 */
      this.currentRow = selectedRow
      this.paramsOfTab = this.currentRow
      await cache.load(cacheName.CONFIG)
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      const loading = getLoading4Cxt(this)
      this.context.loading = true
      try {
        if (selectedRow.uuid) {
          this.rowData = rowData
        } else {
          // CARGO-53866 东丽 新增复制业务 销售默认带入当前登录人
          await JobUtils.loadingDlwlSales(selectedRow, this)
          this.setJobExtraInfo(selectedRow)
          this.rowData = [...rowData, selectedRow]
        }
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.setGridSelect(selectedRow)
      } catch (err) {
        loading.close()
        this.context.loading = false
        throw err
      }
      this.onRowClicked({ data: selectedRow })
    },
    // 切换页面状态
    againShow(action, row) {
      if (action) {
        this.action = action
      }
      if (this.isNew) {
        row = row || {}
      } else {
        row = row || this.currentRow
      }
      this.onShow(this.action, this.rowData, row)
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 设置job的扩展信息
    setJobExtraInfo(job) {
      job.jobUuid = job.uuid
      job.parentUuid = job.lclMasterUuid
      if (job.lclMasterUuid) {
        job.path = job.lclMasterUuid + ',' + job.uuid
      } else {
        job.path = job.uuid
      }
      job.dataType = job.masterFlag ? 1 : 2 // 1 主票 2 小票
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const item of nodes) {
        if (item.data.uuid === row.uuid || !item.data.uuid) {
          item.setSelected(true)
          break
        }
      }
    },
    // 行点击
    async onRowClicked(event) {
      const loading = getLoading4Cxt(this)
      this.context.loading = true
      try {
        await this.context.prepareData(true)
        let data = event.data
        if (this.action === 'edit') {
          data.isCompleteRow = false
        }
        if (this.action === 'look') {
          this.getImGroupFunc(event)
        }
        if (!data.isCompleteRow) {
          if (data.lob === 'SE') {
            const jobModel = new SeaExportJob(data)
            if (data.uuid) {
              await jobModel.loadJobRelated({
                job: !(jobModel.version >= 1), // 脏数据，需要重新载入（不要在此之前，填充默认值，因为version的默认值为1，会让表达式得不到正确的结果）
                seaEQ: true,
                lclSlaves: data.masterFlag,
                charges: true,
                warehouseIn: true,
                warehouseInfo: true,
                trucking: true,
                lclMaster: !data.masterFlag,
                seaCargoDoc: !data.masterFlag,
                containerUsages: true,
                containers: true,
                cargoBulkDetail: !data.masterFlag,
                surchargeTerms: !data.masterFlag,
                dischargingTrucking: true,
                destPortCustomsDataList: true
              })
              // 非主票，组装containers.containerUsage，同job.containerUsages指向同一usage
              if (!data.masterFlag) {
                ContainerUtil.buildContainerUsages(data)
              }
            } else {
              jobModel.seaEQ = jobModel.seaEQ || []
              jobModel.lclSlaves = jobModel.lclSlaves || []
              jobModel.charges = jobModel.charges || []
              jobModel.warehouseIn = jobModel.warehouseIn || []
              jobModel.warehouseInfo = jobModel.warehouseInfo || []
              jobModel.trucking = jobModel.trucking || []
              jobModel.seaCargoDoc = jobModel.seaCargoDoc || []
              jobModel.containerUsages = jobModel.containerUsages || []
              jobModel.containers = jobModel.containers || []
              jobModel.cargoBulkDetail = jobModel.cargoBulkDetail || []
              jobModel.surchargeTerms = jobModel.surchargeTerms || []
              jobModel.dischargingTrucking = jobModel.dischargingTrucking || []
              jobModel.destPortCustomsDataList = jobModel.destPortCustomsDataList || []
            }
            jobModel.fillDefaultValue() // 填充其他默认值
            if (this.isCustomJobTypeJK(jobModel)) {
              jobModel.destinationPortService = true
            }
          } else if (data.lob === 'AE') { // AE
            const jobModel = new AirExportJob(data)
            if (data.uuid) {
              await jobModel.loadJobRelated({
                job: !(jobModel.version >= 1), // 脏数据，需要重新载入（不要在此之前，填充默认值，因为version的默认值为1，会让表达式得不到正确的结果）
                lclSlaves: data.masterFlag,
                charges: true,
                warehouseIn: data.masterFlag,
                warehouseInfo: true,
                trucking: true,
                lclMaster: !data.masterFlag,
                airCargoDoc: true,
                containerUsages: true,
                containers: true,
                dischargingTrucking: true
              })
            } else {
              jobModel.lclSlaves = jobModel.lclSlaves || []
              jobModel.charges = jobModel.charges || []
              jobModel.warehouseIn = jobModel.warehouseIn || []
              jobModel.warehouseInfo = jobModel.warehouseInfo || []
              jobModel.trucking = jobModel.trucking || []
              jobModel.airCargoDoc = jobModel.airCargoDoc || []
              jobModel.containerUsages = jobModel.containerUsages || []
              jobModel.containers = jobModel.containers || []
              jobModel.dischargingTrucking = jobModel.dischargingTrucking || []
            }
            jobModel.fillDefaultValue() // 填充其他默认值
          } else { // RE、RI
            const jobModel = new RailwayExportJob(data)
            if (data.uuid) {
              await jobModel.loadJobRelated({
                job: !(jobModel.version >= 1), // 脏数据，需要重新载入（不要在此之前，填充默认值，因为version的默认值为1，会让表达式得不到正确的结果）
                seaEQ: true,
                lclSlaves: data.masterFlag,
                lclMaster: !data.masterFlag,
                charges: true,
                warehouseIn: true,
                warehouseInfo: true,
                trucking: true,
                containerUsages: true,
                containers: true,
                cargoBulkDetail: !data.masterFlag,
                surchargeTerms: !data.masterFlag
              })
              // 非主票，组装containers.containerUsage，和job.containerUsages里的元素指向同一个对象
              if (!jobModel.masterFlag) {
                ContainerUtil.buildContainerUsages(data)
              }
            } else {
              jobModel.seaEQ = jobModel.seaEQ || []
              jobModel.lclSlaves = jobModel.lclSlaves || []
              jobModel.lclMaster = jobModel.lclMaster || null
              jobModel.charges = jobModel.charges || []
              jobModel.warehouseIn = jobModel.warehouseIn || []
              jobModel.warehouseInfo = jobModel.warehouseInfo || []
              jobModel.trucking = jobModel.trucking || []
              jobModel.containerUsages = jobModel.containerUsages || []
              jobModel.containers = jobModel.containers || []
              jobModel.cargoBulkDetail = jobModel.cargoBulkDetail || []
              jobModel.surchargeTerms = jobModel.surchargeTerms || []
              jobModel.railwayHeadwayTails = jobModel.railwayHeadwayTails || []
            }
            jobModel.fillDefaultValue() // 填充其他默认值
          }
          data.isCompleteRow = true
          // 需重新构造对象，以便新增加的属性可以被vue监听到
          const newData = { ...data }
          /* 替换旧数据 */
          const index = this.rowData.findIndex(p => p === data)
          const node = this.gridApi.rowModel.rowsToDisplay.find(p => p.data === data)
          if (index >= 0 && node) {
            this.rowData[index] = newData
            node.data = newData
          }
          data = newData
        }
        this.currentRow = data
      } finally {
        loading.close()
        this.context.loading = false
      }
      this.initInfo()
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.context.removedData = {}
      this.$nextTick(() => {
        this.resetActiveTabName()
        this.handleTabClick()
      })
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
      }
    },
    // 重置行数据
    reset(rows) {
      for (const row of rows) {
        // 标识为脏数据
        row.version = 0
        // 重置子表数据
        for (const key in row) {
          if (typeof row[key] === 'object') {
            row[key] = ''
          }
        }
        row.isCompleteRow = false
      }
    },
    // 查看
    lookHandler() {
      this.againShow('look')
    },
    // 编辑
    async toEdit() {
      this.$emit('edit', this.currentRow)
    },
    // 复制
    toCopy() {
      this.$emit('copy', this.currentRow)
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row || {})
    },
    // 打印
    onPrint() {
      const job = this.currentRow
      switch (job.lob) {
        case 'SE':
          this.templateSelectorDialog.ctx = new SeaExportJob(job)
          this.templateSelectorDialog.category = 'BOOKING'
          break
        case 'AE':
          this.templateSelectorDialog.ctx = new AirExportJob(job)
          this.templateSelectorDialog.category = 'AEBOOKING'
          break
        case 'RE':
        case 'RI':
          this.templateSelectorDialog.ctx = new RailwayExportJob(job)
          this.templateSelectorDialog.category = 'BOOKING_RE'
          break
      }
      this.templateSelectorDialog.data = { jobuuid: job.uuid, JOB_UUID: job.uuid }
      this.templateSelectorDialog.visible = true
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    initInfo() {
      this.showJobTitle()
    },
    // tab页签切换
    handleTabClick() {
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
      })
    },
    // tab页签结束后的处理（在编辑状态下）
    async endTabHandler(tabName) {
      if (this.action === 'look') {
        return
      }
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // 重置tab页签
    resetTab(tabName) {
      this.pendTabSet.delete(tabName)
    },
    // 重置数据
    resetData(keys) {
      for (const key of keys) {
        this.paramsOfTab[key] = deepCopy(this.currentRow[key])
      }
    },
    // 同步数据
    syncData(data) {
      Object.assign(this.currentRow, data)
    },
    // 保存业务相关数据
    async save() {
      const loading = getLoading4Cxt(this)
      this.context.loading = true
      try {
        // 当前页签结束后的处理
        if (this.activeTabName) {
          await this.endTabHandler(this.activeTabName)
        }
        const body = { action: this.action }
        // 校验目的港清关申报货值（仅远程订舱）
        if (this.pendTabSet.has('tabDestinationCustomsData') && this.$refs.tabDestinationCustomsData) {
          if (!this.$refs.tabDestinationCustomsData.validateDeclaredValue()) {
            return
          }
        } else if (this.paramsOfTab.destPortCustomsClearance) {
          // 勾选了目的港清关但未打开过该页签（懒加载未渲染）时，直接校验行数据，
          // 不通过则跳转到目的港清关页签并初始化，引导用户填写申报货值
          const customsList = this.paramsOfTab.destPortCustomsDataList || []
          const invalid = customsList.length === 0 || customsList.some(item => {
            const val = item.declaredValue
            return val === null || val === undefined || val === '' || Number(val) <= 0
          })
          if (invalid) {
            this.activeTabName = 'tabDestinationCustomsData'
            this.handleTabClick()
            this.$message.warning('申报货值不能小于等于0')
            return
          }
        }
        // 合并各页签的提交数据
        try {
          for (const item of this.pendTabSet) {
            const getSubmitData = this.$refs[item].getSubmitData
            if (getSubmitData && typeof getSubmitData === 'function') {
              let tabData = null
              const result = this.$refs[item].getSubmitData()
              if (result instanceof Promise) {
                tabData = await result
              } else {
                tabData = result
              }
              this.mergeObjectWithUuid(body, tabData)
            }
          }
          this.doNotClickTabData(body)
          // 被联动修改了的数据（新增时，truckingInfo在这里放入到请求参数化中）
          this.mergeObjectWithUuid(body, this.context.modifiedData)
          // 待删除的数据
          this.mergeObjectWithUuid(body, this.context.removedData)
          // 确保 body 中包含 job 数据（修复：定位在非委托页签保存时 job 数据丢失）
          if (!body.job && this.paramsOfTab) {
            body.job = deepCopy(this.paramsOfTab)
          }
          // 清空job子表数据
          if (body.job) {
            // 拷贝一个副本，避免在保存成功前，影响原始数据
            if (body.job === this.paramsOfTab) {
              body.job = deepCopy(body.job)
            }
            for (const key in body.job) {
              if (typeof body.job[key] === 'object') {
                delete body.job[key]
              }
            }
          }
          // 存在有临时uuid 的费用，uuid清空
          if (body.charges && body.charges.length > 0) {
            for (const charge of body.charges) {
              if (!charge.uuid) continue
              if (charge.uuid.startsWith('addTabSelling__') || charge.uuid.startsWith('addTabCost__')) {
                charge.uuid = ''
              }
            }
          }
          cleanCircleObject(body)
        } catch (err) {
          if (err instanceof TabError) {
            this.activeTabName = err.tabName
            if (err.message) {
              this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
            }
            return
          } else {
            throw err
          }
        }
        // 后端触发SOP使用
        if (!this.isNew) {
          body.jobUuid = this.currentRow.uuid
        }
        // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
        await SopUtil.checkSopTemplate(body.job, this, null, null, this.sopTemplateConfig)
        // 在保存前进行校验
        if (!(await this.checkBeforeSave(body.job))) {
          return
        }
        // CARGO-39933，验证规则配置增加远程订舱保存验证节点
        const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
        if (useCheckRule && body.job) {
          const hasCheckRuleForSaveJob = await JobUtils.hasCheckRuleCondition(useCheckRule, CheckRuleConstants.NODE_SAVE_REMOTE_BOOKING.code, this.$store.getters.currentOfficeId)
          if (hasCheckRuleForSaveJob) {
            const result = await JobUtils.checkBySaveJobNode({ ...body, charges: this.paramsOfTab.charges }, this.currentRow.lob, CheckRuleConstants.NODE_SAVE_REMOTE_BOOKING.code)
            if (result.needShowDialog) {
              loading.close()
              this.context.loading = false
              const callBack = async() => { await this.continueSaving(body, loading, true) }
              this.checkingSaveJobWindow.lob = this.currentRow.lob
              this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_REMOTE_BOOKING.code
              this.checkingSaveJobWindow.rowData = result.rowData
              this.checkingSaveJobWindow.callBack = callBack
              this.checkingSaveJobWindow.visible = true
            } else {
              await this.continueSaving(body, loading, false)
            }
          } else {
            await this.continueSaving(body, loading, false)
          }
        } else {
          await this.continueSaving(body, loading, false)
        }
      } finally {
        loading.close()
        this.context.loading = false
      }
    },
    async continueSaving(body, loading, closingLoading = false) {
      try {
        if (closingLoading) {
          loading = getLoading4Cxt(this)
          this.context.loading = true
        }
        // 保存到数据库
        let saveFunc = null
        switch (this.currentRow.lob) {
          case 'SE':
            saveFunc = saveSeaBookingSpace
            break
          case 'AE':
            // 小物件同步
            if (body.job && body.job.insideQuantity) {
              body.job.slac = body.job.insideQuantity
            }
            saveFunc = saveAeBookingSpace
            break
          case 'RE':
          case 'RI':
            saveFunc = saveRailwayExport
            break
        }
        body.source = 'remoteBooking-save'
        // 避免循环引用
        this.resetNoNeedSaveData(body)
        await saveFunc(body).then(res => {
          const result = res.data.job
          if (result) {
            Object.assign(this.currentRow, result)
            this.setJobExtraInfo(this.currentRow)
            this.isRefresh = true
          }
        })
        // webAccept：官网订单接单落单后，先 acceptCallback 回写官网订单（状态=已接单 + jobNo/jobId），
        // 再自动提交订舱预审（跳过下方"是否提交预审"确认弹框）。acceptCallback 必须先于预审——预审 hook 用 jobNo 反查官网订单。
        let webAcceptAutoSubmitted = false
        if (this.webAcceptSourceOrderId && this.currentRow.jobNo && this.currentRow.uuid) {
          try {
            await acceptCallbackWebOrder({
              sourceOrderId: this.webAcceptSourceOrderId,
              jobNo: this.currentRow.jobNo,
              jobId: this.currentRow.uuid
            })
          } catch (e) {
            this.$message.warning('回写官网订单失败：' + ((e && (e.errorMsg || e.message)) || '请稍后在接单列表核对'))
          }
          await this.submitPreverifyState().catch(() => {})
          webAcceptAutoSubmitted = true
          this.webAcceptSourceOrderId = ''
        }
        // 复制
        let c = true
        if (this.currentRow.copyNum && this.currentRow.uuid) {
          const copyNum = Number(this.currentRow.copyNum)
          if (copyNum > 1) {
            c = false
            await this.saveCopyJobHandle(this.currentRow.uuid, copyNum - 1, this.currentRow.danUNNo)
          }
          delete this.currentRow.copyNum
        }
        // 批量复制不弹出自动提交弹框
        if ([3, 4].includes(this.currentRow.preverifyState) && c && !webAcceptAutoSubmitted) {
          const flag = await this.$confirm(this.$t('CargoMsg.Cargo_SSSFPR'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('constant.yes'),
            cancelButtonText: this.$t('constant.no'),
            closeOnClickModal: false,
            showClose: false,
            type: 'info'
          }).then(() => true).catch(() => false)
          if (flag) {
            // 判断是否开启验证规则
            const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
            // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, CheckRuleConstants.NODE_REMOTE_BOOKING.code, opOffice)
            const hasCheckRule = true
            if (useCheckRule && hasCheckRule) {
              /* 封装异步操作，等待返回结果后，继续往下执行 */
              let resolveRef = null
              let rejectRef = null
              const checkResult = new Promise((resolve, reject) => {
                resolveRef = resolve
                rejectRef = reject
              })
              this.checkingManager(CheckRuleConstants.NODE_REMOTE_BOOKING.code, resolveRef, null, rejectRef)
              const checkPass = await checkResult.then(() => true).catch(() => false)
              if (checkPass) {
                await this.submitPreverifyState()
              }
            } else {
              await this.submitPreverifyState()
            }
          }
        }
        /* 重置受影响的行数据 */
        let dirtyRows = null
        if (this.currentRow.masterFlag) {
          dirtyRows = this.rowData.filter(p => p.lclMasterUuid === this.currentRow.uuid)
        } else if (this.currentRow.lclMasterUuid) {
          dirtyRows = this.rowData.filter(p => p.uuid === this.currentRow.lclMasterUuid)
        }
        this.reset(dirtyRows ? [...dirtyRows, this.currentRow] : [this.currentRow])
        if (this.isNew) {
          this.gridApi.setRowData(this.rowData)
        }
        // 保存成功后执行各业签的回调方法
        for (const item of this.pendTabSet) {
          const executeTask = this.$refs[item].executeTask
          if (executeTask && typeof executeTask === 'function') {
            const result = this.$refs[item].executeTask()
            if (result instanceof Promise) {
              await result
            }
          }
        }
        if (JobUtils.isBlockJob(this.currentRow)) {
          // 保存成功之后如果是信控锁住则会弹此提示【Job.as中的save方法】
          setTimeout(() => {
            this.$message.warning(this.$t('SeaExport.CheckCreditSaveTip'))
          }, 2000)
        }
        this.currentRow.isCompleteRow = false
        this.againShow('look', this.currentRow)
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        // CARGO-7244 远程订舱回写报价单job号
        if (this.currentRow.quotationUuid && this.currentRow.jobNo) {
          const conMap = {
            quotationUuid: this.currentRow.quotationUuid,
            jobNo: this.currentRow.jobNo
          }
          setQuotationJobNo({ conMap }).then((res) => {
            if (res.data) console.log('回写报价单job号成功。')
          })
        }
      } catch (err) {
        throw err
      } finally {
        if (closingLoading) {
          loading.close()
          this.context.loading = false
        }
      }
    },
    // 避免循环引用
    resetNoNeedSaveData(body) {
      if (body.containers && body.containers.length > 0) {
        for (const container of body.containers) {
          if (container.containerUsage && container.containerUsage.length > 0) {
            for (const containerUsage of container.containerUsage) {
              delete containerUsage.container
            }
          }
        }
      }
    },
    // 保存剩下的复制业务【后台复制并保存】
    async saveCopyJobHandle(jobUuid, copyNum, danUNNo) {
      const item = {}
      item.jobUuid = jobUuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.currentRow.lob
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
      item.copyNum = copyNum
      item.all = true
      item.source = 'remoteBooking'
      item.copyOnly = true // 是否是复制业务，新增业务日志时使用
      let saveFunc = null
      switch (this.currentRow.lob) {
        case 'SE':
          item.danUNNo = danUNNo
          saveFunc = saveCopyJob
          break
        case 'AE':
          saveFunc = aeSaveCopyJob
          break
        case 'RE':
        case 'RI':
          saveFunc = railwaySaveCopyJob
          break
      }
      await saveFunc(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setJobExtraInfo(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 合并对象属性，通过比较uuid判断对象是否相等
    mergeObjectWithUuid(target, source) {
      for (const key in source) {
        const srcValue = source[key]
        const targetValue = target[key]
        if ((srcValue instanceof Array) && (targetValue instanceof Array)) {
          for (const item of srcValue) {
            const index = targetValue.findIndex(p => p.uuid === item.uuid && p.uuid)
            if (index < 0) {
              targetValue.push(item)
            }
          }
        } else {
          target[key] = srcValue
        }
      }
    },
    // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
    doNotClickTabData(body) {
      const isCopy = this.action === 'copy'
      const isAdd = this.action === 'add'
      const job = this.currentRow
      if (!body || !job || (!isCopy && !isAdd)) return
      // 复制独有
      if (isCopy) {
        if (job.charges && job.charges.length > 0) {
          if (Object.prototype.hasOwnProperty.call(body, 'charges')) {
            for (const item of job.charges) {
              const index = body.charges.findIndex(p => p === item || (p.receivable === item.receivable && p.serialNumber && p.serialNumber === item.serialNumber))
              if (index < 0) {
                body.charges.push(item)
              }
            }
          } else {
            Object.assign(body, { charges: job.charges })
          }
        }
      } else if (isAdd) {
        // CARGO-46002通过报价单生成订单，会跳转到远程订舱，在基本页签，填写完信息后，直接点击保存后，未生成费用。
        if (job.charges.length > 0 && !Object.prototype.hasOwnProperty.call(body, 'charges')) {
          Object.assign(body, { charges: job.charges })
          if (body.job) {
            // 计算预估信息
            EstimateProfitUtil.calculateEstimatedInformation(body.job, job.charges)
          }
        }
      }
    },
    // 在保存前进行校验
    async checkBeforeSave(bodyJob) {
      const job = this.paramsOfTab
      const jobForCheck = bodyJob || job
      // 业务规则：自定义业务类型=C类时，发货人/收货人/通知人必填（任一字段非空视为已填）
      if (jobForCheck && this.isCustomJobTypeC(jobForCheck)) {
        const tabName = this.getConsignationTabNameByLob(jobForCheck.lob)
        const requireParty = (label, keys) => {
          if (this.hasAnyValue(jobForCheck, keys)) return true
          // 引导用户回到“委托/基本”页签填写
          if (tabName) this.activeTabName = tabName
          this.$message.warning(`${label}不能为空`)
          return false
        }
        if (!requireParty('发货人', ['shipperLine1', 'shipperLine2', 'shipperLine3', 'shipperLine4', 'shipperLine5', 'shipperLine6'])) return false
        if (!requireParty('收货人', ['consigneeLine1', 'consigneeLine2', 'consigneeLine3', 'consigneeLine4', 'consigneeLine5', 'consigneeLine6'])) return false
        if (!requireParty('通知人', ['notifyLine1', 'notifyLine2', 'notifyLine3', 'notifyLine4', 'notifyLine5', 'notifyLine6'])) return false
        if (!requireParty('HS编号', ['hsCode'])) return false
      }
      // 业务规则：自定义业务类型=J类或K类时，尾程商务负责人必填（远程订舱保存同样校验）
      if (jobForCheck && jobForCheck.lob === 'SE' && this.isCustomJobTypeJK(jobForCheck) && !jobForCheck.lastMilePlanner) {
        // 引导用户回到“委托/基本”页签填写
        this.activeTabName = 'tabSeBooking'
        this.$message.warning(this.$t('Message.FieldValueCannotBeNull', [this.$t('CargoMsg.Cargo_LastMileBusinessLeader')]))
        return false
      }
      // 业务规则：DDP业务类型时，尾程商务负责人必填（远程订舱保存同样校验）
      if (jobForCheck && this.isCustomJobTypeDDP(jobForCheck) && !jobForCheck.userDefinedRoleId6) {
        // 引导用户回到“委托/基本”页签填写
        this.activeTabName = this.getConsignationTabNameByLob(jobForCheck.lob)
        this.$message.warning(this.$t('Message.FieldValueCannotBeNull', [this.$t('CargoMsg.Cargo_LastMileBusinessLeader')]))
        return false
      }
      // 业务规则：贸易条款不为FOB时，航线负责人必填（远程订舱保存同样校验）
      if (jobForCheck && jobForCheck.lob === 'SE' && jobForCheck.incoTerm && String(jobForCheck.incoTerm).toUpperCase() !== 'FOB' && !jobForCheck.planner) {
        this.activeTabName = 'tabSeBooking'
        this.$message.warning('贸易条款不为FOB时，航线负责人必填')
        return false
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(job.customerId, !(job.uuid && job.customerId === this.currentRow.customerId))
      if (blacklist) {
        if (!job.uuid || (job.uuid && job.customerId !== this.currentRow.customerId)) {
          return false
        }
      }
      const reqInputCharge = Number(this.context.config.get('saveCharge')) === 1
      const isBookingFeeMandatoryAppliedGlobally = Number(this.context.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
      if (!SecurityUtil.checkSaveCharge(reqInputCharge, job, isBookingFeeMandatoryAppliedGlobally)) {
        return false
      }
      let flag = await CreditControlUtil.checkCreditBlack(job, !blacklist, this.currentRow)
      if (!flag) {
        return false
      }
      if (!job.uuid) {
        flag = await EstimateProfitUtil.checkEstimate(job, params => {
          let resolveRef = null
          const result = new Promise(resolve => {
            resolveRef = resolve
          })
          const dialog = this.estimateValidationDialog
          dialog.job = params.job
          dialog.estimateProfitRate = params.estimateProfitRate
          dialog.tatolProfit = params.tatolProfit
          dialog.callback = isSave => {
            resolveRef(isSave)
          }
          dialog.visible = true
          return result
        })
        if (bodyJob) {
          bodyJob.estimateAccountsReceivable = job.estimateAccountsReceivable
          bodyJob.estimateAccountsPayable = job.estimateAccountsPayable
          bodyJob.estimateAccountsPayable = job.estimateAccountsPayable
          bodyJob.situation = job.situation
        }
        if (!flag) {
          return false
        }
      }
      flag = await this.checkChargeAccountId()
      if (!flag) {
        return false
      }
      const needConfirmProjectNo = Number(this.context.config.get('needConfirmProjectNo')) === 1
      // needConfirmProjectNo【是否要验证项目编号重复】; openProjectConfig【是否开启项目管理】
      if (job.poNo && needConfirmProjectNo && Number(this.context.config.get('openProjectConfig')) === 0) {
        flag = await JobUtils.isPoNoExist(job.poNo, job.uuid)
        if (!flag) {
          return false
        }
      }
      const needConfirmeDuplicateWarehouseNo = Number(this.context.config.get('needConfirmeDuplicateWarehouseNo')) === 1
      if (needConfirmeDuplicateWarehouseNo && job.warehouseNo) {
        if (job.lob === 'SE') {
          const result = await SeaExportJob.checkJobFieldExist(this.context.office.officeId, job.lob, { warehouseNo: job.warehouseNo }, job.uuid)
          flag = await this.checkWarehouseNo(result.warehouseNo)
        } else if (job.lob === 'AE') {
          const body = {
            branchId: this.context.office.officeId,
            jobKey: job.uuid,
            fieldMap: { warehouseNo: job.warehouseNo }
          }
          const res = await validateMBL(body)
          if (res.data && res.data.field) {
            switch (res.data.field) {
              case 'warehouseNo':
                flag = await this.$confirm(this.$t('Payment.warehouseNo') + res.data.value + this.$t('CargoMsg.Cargo_Existed') + '\n' + this.$t('Message.Save'), this.$t('Message.Prompt'), {
                  confirmButtonText: this.$t('constant.yes'),
                  cancelButtonText: this.$t('constant.no'),
                  closeOnClickModal: false,
                  type: 'info'
                }).then(() => true).catch(() => false)
                break
              default:
                break
            }
          }
        } else if (job.lob === 'RE' || job.lob === 'RI') {
          const result = await RailwayExportJob.checkJobFieldExist(this.context.office.officeId, job.lob, { warehouseNo: job.warehouseNo }, job.uuid)
          flag = await this.checkWarehouseNo(result.warehouseNo)
        }
      }
      return flag
    },
    // 自定义业务类型为 J类 / K类 时，需要填写尾程商务负责人
    isCustomJobTypeJK(job) {
      const code = job && job.customJobType
      if (!code) return false
      // 大部分环境自定义业务类型的 code 就是单字母（J/K）
      if (code === 'J' || code === 'K') return true
      // 兼容 code 不是 J/K，但名称为 J类/K类 的情况（需按 lob 区分）
      const item = resolveSpecificField2ItemByCustomType(cacheKeys.basic_data_CutomJobType, 'code', code, job.lob)
      const name = (item && (item.localName || item.name || item.englishName)) || ''
      return name.startsWith('J类') || name.startsWith('K类')
    },
    // 自定义业务类型为 C类 时的判断（兼容 code/name 两种情况）
    isCustomJobTypeC(job) {
      const code = job && job.customJobType
      if (!code) return false
      // 大部分环境自定义业务类型的 code 就是单字母（C）
      if (code === 'C') return true
      // 兼容 code 不是 C，但名称为 C类 的情况（需按 lob 区分）
      const item = resolveSpecificField2ItemByCustomType(cacheKeys.basic_data_CutomJobType, 'code', code, job.lob)
      const name = (item && (item.localName || item.name || item.englishName)) || ''
      return name.startsWith('C类')
    },
    // 自定义业务类型为 DDP 时，需要填写尾程商务负责人
    isCustomJobTypeDDP(job) {
      const code = job && job.customJobType
      if (!code) return false
      // 检查是否为DDP相关业务类型
      return code === 'DDP' || code === 'EDDP' || code === 'REDDP' || code === 'RIDDP'
    },
    // 任意字段非空（去除空白/零宽字符后）视为已填写
    hasAnyValue(obj, keys) {
      if (!obj || !keys || keys.length === 0) return false
      return keys.some(k => {
        const val = obj[k]
        if (val === null || val === undefined) return false
        const s = typeof val === 'string' ? val : String(val)
        // 兼容零宽字符（ZWSP/ZWNJ/ZWJ/BOM）导致的“看起来是空但校验通过”
        return s.replace(/[\s\u200B-\u200D\uFEFF]/g, '') !== ''
      })
    },
    getConsignationTabNameByLob(lob) {
      switch (lob) {
        case 'SE':
          return 'tabSeBooking'
        case 'AE':
          return 'tabAeBooking'
        case 'RE':
        case 'RI':
          return 'tabReBooking'
        default:
          return this.getDefaultActiveName()
      }
    },
    // 验证费用结算对象
    async checkChargeAccountId() {
      const job = this.paramsOfTab
      let messageTitle = ''
      let company = null
      if (job.charges && job.charges.length > 0) {
        for (const charge of job.charges) {
          if (charge.accountId > 0) {
            company = this.context.companyList.find(p => p.cmpIdx === charge.accountId)
            if (company && !company.active) {
              if (!this.chargeAccountIdObject || !this.chargeAccountIdObject[company.uuid]) {
                if (company.chineseName) {
                  messageTitle = this.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.chineseName)
                } else {
                  messageTitle = this.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.englishName)
                }
                break
              }
            }
          }
        }
      }
      if (messageTitle) {
        return await this.$confirm(messageTitle, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.chargeAccountIdObject = this.chargeAccountIdObject || {}
          this.chargeAccountIdObject[company.uuid] = company.uuid
          return true
        }).catch(() => false)
      } else {
        return true
      }
    },
    // 检测WarehouseNo是否重复
    async checkWarehouseNo(isExist) {
      if (isExist) {
        return await this.$confirm(this.$t('Message.WHNoRepeatedContinue'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => true).catch(() => false)
      }
      return true
    },
    // 验证规则配置公用
    checkingManager(checkNode, callBack, callBack2, closeHandler) {
      let checkType = true
      if (this.currentRow.masterFlag) {
        const lclSlaves = this.currentRow.lclSlaves
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = [this.currentRow, ...lclSlaves]
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.closeHandler = closeHandler
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.closeHandler = closeHandler
        this.checkingWindow.visible = true
      }
    },
    async submitPreverifyState() {
      // const job = { ...this.currentRow }
      // for (const key in job) {
      //   if (typeof job[key] === 'object') {
      //     delete job[key]
      //   }
      // }
      // job.preverifyState = 1
      // 保存到数据库
      // let saveFunc = null
      // switch (this.currentRow.lob) {
      //   case 'SE':
      //     saveFunc = saveSeaBookingSpace
      //     break
      //   case 'AE':
      //     saveFunc = saveAeBookingSpace
      //     break
      //   case 'RE':
      //   case 'RI':
      //     saveFunc = saveRailwayExport
      //     break
      // }
      try {
        let func = submitPreVerifyState
        // 没有干线 或者 是FOB 直接进入正式业务
        if (this.currentRow.lob === 'SE' && this.isHc && this.currentRow.incoTerm === 'FOB') {
          func = submitSkipPreVerify
        }
        if (this.currentRow.uuid) {
          await func({ jobUuid: this.currentRow.uuid }).then(res => {
            const result = res.data
            if (result) {
              Object.assign(this.currentRow, result)
            }
          }).catch()
        }
      } catch (err) {
        this.$logger.log('提交预审状态失败：' + err)
      }
    },
    // 取消编辑
    cancelEdit() {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (this.isNew) {
          if (this.rowData.length > 1) {
            this.rowData = this.rowData.filter(p => p.uuid)
            this.currentRow = this.rowData[0]
            this.lookHandler()
          } else {
            this.goBack()
          }
        } else if (this.action === 'edit') {
          this.lookHandler()
        }
      }).catch()
    },
    saveDefaultVal() {
      const entityCodes = ['Job']
      if (this.paramsOfTab.lob === 'SE') {
        entityCodes.push('SeaExportJob')
      } else if (this.paramsOfTab.lob === 'AE') {
        entityCodes.push('AirExportJob')
      } else if (this.paramsOfTab.lob === 'RE' || this.paramsOfTab.lob === 'RI') {
        entityCodes.push('RailwayExportJob')
      }
      const loading = getLoading4Cxt(this)
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(entityCodes, this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    },
    goBack() {
      this.$store.dispatch('app/setCanCloseModule', true)
      this.$emit('back', this.isRefresh)
    },

    // ==============以下是 报价管理 新建委托处理===================
    createRemoteBooking(type, job, from) {
      this.action = type
      switch (job.lob) {
        case 'AE': {
          // zrd todo 带的字段支持 拼箱、空运
          this.addFromPriceAirExportJob(job)
          break
        }
        default: {
          if (from === 'AI') {
            this.addFromPriceSeaExport(job, true)
          } else {
            this.addFromPriceSeaExport(job)
          }
          break
        }
      }
    },
    /**
     * 报价单关联委托
     */
    async addFromPriceSeaExport(job, flag) {
      const seaJob = new SeaExportJob().fillDefaultValue().getData()
      if (flag) {
        for (const key in job) {
          if (Object.prototype.hasOwnProperty.call(seaJob, key)) {
            if (key === 'charges' && job[key].length > 0) {
              let receivableNum = 0
              let payableNum = 0
              for (const charge of job.charges) {
                const c = lodash.cloneDeep(charge)
                if (c.receivable) {
                  c.accountId = seaJob.customerId
                  c.serialNumber = receivableNum
                  receivableNum++
                } else {
                  c.serialNumber = payableNum
                  payableNum++
                }
                c.jobUuid = seaJob.uuid
                if (!seaJob.charges || seaJob.charges.length <= 0) seaJob.charges = []
                seaJob.charges.push(c)
              }
              continue
            }
            if (key === 'seaEQ' && job[key].length > 0) {
              for (const seaEq of job.seaEQ) {
                const s = lodash.cloneDeep(seaEq)
                s.jobUuid = seaJob.uuid
                if (!seaJob.seaEQ || seaJob.seaEQ.length <= 0) seaJob.seaEQ = []
                seaJob.seaEQ.push(s)
              }
              continue
            }
            seaJob[key] = job[key]
          }
        }
        seaJob.remarks = job.remarks
        seaJob.containerLoadType = StrUtils.isEmpty(job.containerLoadType2) ? 'FCL' : job.containerLoadType2
        seaJob.priceTier = StrUtils.isEmpty(seaJob.priceNo) ? 1 : job.priceTier
      } else {
        seaJob.remarks = job.remarks
        seaJob.customerId = job.customerId
        seaJob.carrierId = job.carrierId
        seaJob.dispatchingPlace = job.dispatchingPlace
        seaJob.loadingPortCode = job.loadingPortCode
        seaJob.dischargingPortCode = job.dischargingPortCode
        seaJob.destinationPortCode = job.dischargingPortCode
        seaJob.cargoChineseName = job.cargoChineseName
        seaJob.cargoEnglishName = job.cargoEnglishName
        seaJob.hsCode = job.hsCode
        seaJob.weightContract = job.weightContract
        seaJob.cubageContract = job.cubageContract
        seaJob.quantityContract = job.quantityContract
        seaJob.chargeWeight = job.chargeWeight
        seaJob.priceNo = job.priceNo
        seaJob.containerLoadType = StrUtils.isEmpty(job.containerLoadType2) ? 'FCL' : job.containerLoadType2
        seaJob.priceTier = StrUtils.isEmpty(seaJob.priceNo) ? 1 : job.priceTier
        seaJob.priceSource = job.priceSource
        seaJob.bookingAgent = job.bookingAgent
        seaJob.etd = job.etd
        seaJob.freeTime = job.tmpFreeTime
        seaJob.vesselLineCode = job.tmpVesselLineCode
        seaJob.quotationUuid = job.quotationUuid
        seaJob.quotationNo = job.quotationNo
        seaJob.userDefinedField1 = job.userDefinedField1
        seaJob.userDefinedField2 = job.userDefinedField2
        seaJob.userDefinedField3 = job.userDefinedField3
        seaJob.userDefinedField4 = job.userDefinedField4
        const company = await Company.getCompanyById(seaJob.customerId)
        if (job.charges && job.charges.length > 0) {
          let receivableNum = 1
          let payableNum = 1
          for (const charge of job.charges) {
            const c = lodash.cloneDeep(charge)
            if (c.receivable) {
              c.accountId = seaJob.customerId
              if (company) {
                c.oversea = (company.designationAgent || company.overseaAgent) // 指定货代理/目的港代理
              }
              c.serialNumber = receivableNum
              receivableNum++
            } else {
              c.serialNumber = payableNum
              payableNum++
            }
            c.jobUuid = seaJob.uuid
            if (!seaJob.charges || seaJob.charges.length <= 0) seaJob.charges = []
            seaJob.charges.push(c)
          }
        }
        if (job.seaEQ && job.seaEQ.length > 0) {
          for (const seaEq of job.seaEQ) {
            const s = lodash.cloneDeep(seaEq)
            s.jobUuid = seaJob.uuid
            if (!seaJob.seaEQ || seaJob.seaEQ.length <= 0) seaJob.seaEQ = []
            seaJob.seaEQ.push(s)
          }
        }
      }
      seaJob.lob = 'SE'
      seaJob.jobState = -1
      // 预审状态默认为4暂不提交,特价申请默认状态为5 【isSpecialPrice 参数貌似没用】
      seaJob.preverifyState = 4
      // seaJob.preverifyState = view.isSpecialPrice ? 5 : 4
      seaJob.opOffice = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOffice()
      seaJob.currency = localCurrency
      seaJob.freightTerm = 'CY-CY'
      seaJob.freightTermHBL = 'CY-CY'
      seaJob.bookingTerm = 'OS'
      seaJob.cargoSource = CargoSource.SC_CARGO_SOURCE.code
      seaJob.cargoType = 'GC'
      seaJob.paymentTermMBL = seaJob.paymentTermMBL || 'CCBYCC'
      if (job.inquiryPriceNo) {
        seaJob.inquiryPrice = job.inquiryPrice
        seaJob.selectedPrePortData = job.selectedPrePortData
        seaJob.inquiryPriceNo = job.inquiryPriceNo
        seaJob.prePortQuotationNo = job.prePortQuotationNo
        seaJob.quotationNo = job.quotationNo
        seaJob.lastMileQuotationNo = job.lastMileQuotationNo
        seaJob.prePortPlanner = job.prePortPlanner || 0
        seaJob.planner = job.planner || 0
        seaJob.lastMilePlanner = job.lastMilePlanner || 0
        seaJob.prePortApproveStatus = job.prePortApproveStatus || 0
        seaJob.trunkLineApproveStatus = job.trunkLineApproveStatus || 0
        seaJob.lastMileApproveStatus = job.lastMileApproveStatus || 0
        seaJob.prePortPlannerDepartment = job.prePortPlannerDepartment || 0
        seaJob.plannerDepartment = job.plannerDepartment || 0
        seaJob.lastMilePlannerDepartment = job.lastMilePlannerDepartment || 0
        seaJob.prePortPlannerOffice = job.prePortPlannerOffice || 0
        seaJob.lastMilePlannerOffice = job.lastMilePlannerOffice || 0
        seaJob.freeTime = job.freeTime || 0
        seaJob.customerId = job.customerId || 0
        seaJob.cargoEnglishName = job.cargoEnglishName
        seaJob.showBargeCustomCutoff = job.showBargeCustomCutoff
        seaJob.bargePOL = job.bargePOL
        seaJob.loadingPortCode = job.loadingPortCode
        seaJob.transfering = job.transfering || false
        seaJob.transferPortCode = job.transferPortCode
        seaJob.dischargingPortCode = job.dischargingPortCode
        seaJob.destinationAgent = job.destinationAgent || 0
        seaJob.carryingCmp = job.carryingCmp || 0
        seaJob.cargoType = job.cargoType
        seaJob.incoTerm = job.incoTerm
        seaJob.landTransportation = job.landTransportation || false
        seaJob.priceSource = job.priceSource
        seaJob.salesOffice = job.salesOffice || 0
        seaJob.salesDepartment = job.salesDepartment || 0
        seaJob.rateType = job.rateType || ''
        seaJob.etd = job.etd
        seaJob.carrierId = job.carrierId || 0
        seaJob.weightContract = job.weightContract || 0
        seaJob.weightActual = job.weightActual || 0
      }
      this.addSeaExportJob(seaJob)
    },
    /**
     * 新增海运订舱
     */
    addSeaExportJob(job) {
      this.$nextTick(() => {
        this.onShow(this.action || 'look', [], job)
      })
    },
    /**
     * @private
     */
    addFromPriceAirExportJob(job) {
      const airJob = new AirExportJob().fillDefaultValue().getData()
      airJob.remarks = job.remarks
      airJob.customerId = job.customerId
      airJob.carrierId = job.carrierId
      airJob.dispatchingPlace = job.dispatchingPlace
      airJob.loadingPortCode = job.loadingPortCode
      airJob.dischargingPortCode = job.dischargingPortCode
      airJob.destinationPortCode = job.dischargingPortCode
      airJob.cargoChineseName = job.cargoChineseName
      airJob.cargoEnglishName = job.cargoEnglishName
      airJob.hsCode = job.hsCode
      airJob.weightContract = job.weightContract
      airJob.cubageContract = job.cubageContract
      airJob.quantityContract = job.quantityContract
      airJob.chargeWeight = job.chargeWeight
      airJob.priceNo = job.priceNo
      airJob.operateType = 2
      airJob.priceTier = StrUtils.isEmpty(airJob.priceNo) ? 1 : job.priceTier
      airJob.priceSource = job.priceSource
      airJob.bookingAgent = job.bookingAgent
      airJob.etd = job.etd
      airJob.quotationUuid = job.quotationUuid
      airJob.quotationNo = job.quotationNo
      airJob.userDefinedField1 = job.userDefinedField1
      airJob.userDefinedField2 = job.userDefinedField2
      airJob.userDefinedField3 = job.userDefinedField3
      airJob.userDefinedField4 = job.userDefinedField4
      airJob.danUNNo = job.danUNNo
      if (job.charges && job.charges.length > 0) {
        let receivableNum = 1
        let payableNum = 1
        for (const charge of job.charges) {
          const c = lodash.cloneDeep(charge)
          c.inputByDep = this.$store.getters.currentDept.departmentId
          c.branchId = this.$store.getters.currentOfficeId
          c.jobUuid = airJob.uuid
          if (c.receivable) {
            c.serialNumber = receivableNum
            receivableNum++
          } else {
            c.serialNumber = payableNum
            payableNum++
          }
          if (!airJob.charges || airJob.charges.length <= 0) airJob.charges = []
          airJob.charges.push(c)
        }
      }
      this.changeAirExportJobTab(airJob)
    },
    /**
     * @private
     */
    changeAirExportJobTab(job) {
      job.lob = 'AE'
      job.jobState = -1
      job.preverifyState = 4 // 预审状态默认为4暂不提交
      job.opOffice = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOffice()
      job.currency = localCurrency
      this.$nextTick(() => {
        this.onShow(this.action || 'look', [], job)
      })
    },
    // im入口值返回
    async getImGroupFunc(paramsOfTab) {
      const result = paramsOfTab.data
      if (!this.imCacheKey || !result || (result && !result.jobNo)) {
        return
      }
      let etdTime = ''
      if (result && result.etd) {
        etdTime = result.etd.slice(0, 10)
      } else {
        etdTime = ''
      }
      let type = ''
      let typeValue = 'dischargingPortCode'
      console.log('result.lob====', result)
      switch (result.lob) {
        case 'SE':
          type = TYPE_NAMES.basic_data_Seaport
          break
        case 'SI':
          type = TYPE_NAMES.basic_data_Seaport
          break
        case 'AE':
          type = TYPE_NAMES.basic_data_Airport
          break
        case 'AI':
          type = TYPE_NAMES.basic_data_Airport
          break
        case 'RE':
          type = TYPE_NAMES.basic_data_RailwayStation
          typeValue = 'destinationStation'
          break
        case 'RI':
          type = TYPE_NAMES.basic_data_RailwayStation
          typeValue = 'destinationStation'
          break
      }
      const imGroupName = `${result.jobNo}-${etdTime}-${ColumnUtils.resolveColumnLabel(type, 'code', result[typeValue], 'englishName')}`
      const userInfo = this.$store.getters.userInfo
      // 销售 揽货销售 海外客服 航线负责人 现场操作 单证 自定义岗位1 自定义岗位2
      const personnel = ['sales', 'cargoSalesId', 'overseaOp', 'planner', 'siteOP', 'dc', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'op']
      const data = {
        tenantId: userInfo.tenantId,
        cargowareCompanyId: result.customerId, // cargoware的合作伙伴，对应b2b的订舱公司
        loginUserId: userInfo.userId,	// 登陆人userId
        customerEmail: result.contactEmail, // 客户邮箱
        otherUserIdList: [userInfo.userId], // 其他内部人userId，userName
        docId: result.jobNo, // 单据Id
        type: '' // 单据type
      }
      if (!data.customerEmail) {
        await this.loadCustomer(data, result)
      }
      for (const item of personnel) {
        if (result[item]) {
          data.otherUserIdList.push(result[item])
        }
      }
      this.$refs.cargoIm.onShow(data, imGroupName)
    },
    async loadCustomer(data, result) {
      console.log('result.customerId======', result)
      let company = { cmpIdx: result.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === result.customerContact) {
            data.customerEmail = contact.email
            break
          }
        }
      }
    },
    async showJobTitle() {
      const job = this.currentRow
      let jobTitle = ''
      if (job.customerId) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await Company.loadCustomer(cmp.uuid).then(data => {
            const customerDetail = data.length > 0 ? data[0] : null
            if (customerDetail) {
              const str1 = ` ${this.$t('Message.BillingType')}[${this.$t('Message.ByTicket')}]`
              const str2 = `${this.$t('Message.BillingType')}[${this.$t('Message.Monthly')}]`
              return customerDetail.invoiceMode === 0 ? str1 : str2
            }
            return ''
          })
          jobTitle = '<span style="margin-right:10px">' + cmp.chineseName + creditTerm + '</span><span>' + billingType + '</span>'
        }
      }
      this.commonInfo.jobTitle = jobTitle
    },
    setSaleRoleHideData() {
      console.log('主应用发送SaleRoleHide:', this.saleRoleHideData)
      microApp.forceSetData('child-sale-role-hide-remotebooking', this.saleRoleHideData)
    },
    saleRoleHideDataChange(e) {
      console.log('主应用获取SaleRoleHide:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setSaleRoleHideData()
        } else {
          this.saleRoleHide = e.detail.data.hide
        }
      }
    },
    setCustomerSalesDisplayData() {
      console.log('主应用发送CustomerSalesDisplay:', this.customerSalesDisplayData)
      microApp.forceSetData('child-customer-sales-display-remotebooking', this.customerSalesDisplayData)
    },
    customerSalesDisplayDataChange(e) {
      console.log('主应用获取CustomerSalesDisplay:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setCustomerSalesDisplayData()
        } else {
          this.customerSalesDisplay = e.detail.data.notDisplay
        }
      }
    },
    // 作废
    async toRevoke() {
      if (this.currentRow.preverifyState !== 4) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotSubmittedOrRejectedTips'))
        return
      }
      const jobKeys = Array.from([this.currentRow], p => p.uuid)
      const loading = getLoading4Cxt()
      const res = await validateRevokeJob({ jobKeys }).finally(() => {
        loading.close()
      })
      this.handleRevoke(res.data, jobKeys)
    },
    // 作废验证结构
    handleRevoke(delMap, jobKeys) {
      if (!delMap.hasOwnProperty('status')) {
        if (!this.isZh) {
          delMap.msg = delMap.msg.replace(this.$t('Message.PleaseRemoveTheTicketFirst'), 'please remove the ticket first')
          delMap.msg = delMap.msg.replace(this.$t('Message.ExpenseHasBeenEntered'), 'expense has been entered')
          delMap.msg = delMap.msg.replace(this.$t('Message.ConsolidationHasBeenDone'), 'consolidation has been done')
        }
        this.$message.warning(delMap.msg)
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SuredRevokeJob'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const loading = getLoading4Cxt()
        try {
          const res = await batchRevokeJob({ jobKeys: jobKeys })
          if (res.data) {
            Object.assign(this.currentRow, res.data[0])
            this.gridApi.refreshCells({ force: true })
            this.$message.success(this.$t('CargoMsg.Cargo_VoidedSuccessfully'))
          }
        } finally {
          loading.close()
        }
      }).catch(() => { })
    }
  }
}
</script>
